export default __webpack_public_path__ + "static/media/redeemed_clink.6a0dab32.gif";